module.exports = __webpack_public_path__ + "img/Apache.76db0f7.svg";